import { Country } from '@immosky/types';

export type SearchTermType = 'ambiguous' | 'objectId' | 'region';

export type SearchTermParserResult =
  | {
      type: 'ambiguous';
      value: string;
    }
  | {
      type: 'objectId';
      value: number;
    }
  | {
      type: 'region';
      value: string;
    };

export abstract class SearchTermParser {
  abstract parse(term: string): SearchTermParserResult;
}

export class SwissSearchTermParser extends SearchTermParser {
  parse(term: string): SearchTermParserResult {
    const isObjectId = term.match(/^[0-9]{5,6}$/);

    if (isObjectId) {
      return {
        type: 'objectId',
        value: parseInt(term),
      };
    } else {
      return {
        type: 'region',
        value: term,
      };
    }
  }
}

export class FrenchSearchTermParser extends SearchTermParser {
  parse(term: string): SearchTermParserResult {
    const couldBePostCodeOrObjectId = term.match(/^[0-9]{5}$/);
    const isDefinitelyObjectId = term.match(/^[0-9]{6}$/);

    if (couldBePostCodeOrObjectId) {
      return {
        type: 'ambiguous',
        value: term,
      };
    } else if (isDefinitelyObjectId) {
      return {
        type: 'objectId',
        value: parseInt(term),
      };
    } else {
      return {
        type: 'region',
        value: term,
      };
    }
  }
}

export class SearchTermParserFactory {
  constructor(private country: Country) {}

  create(): SearchTermParser {
    switch (this.country) {
      case 'CH':
        return new SwissSearchTermParser();
      case 'FR':
        return new FrenchSearchTermParser();
      default:
        return new SwissSearchTermParser();
    }
  }
}
